import expandIcon from "../../../assets/icons/newDesign/expand.svg";
import "./VitalCard.css";

const VitalCard = ({ vital, icon, name, hasDetail, mirrorIcon, getLocalizedResultText, onClick }) => {
  const cardContent = (
    <>
      <div className="vital-card-header">
        <div className="vital-name">{name}</div>
        {icon && (
          <div className={`vital-icon${mirrorIcon ? " vital-icon--mirrored" : ""}`}>
            <img src={icon} alt={name} />
          </div>
        )}
      </div>
      <div className="vital-value-container">
        {vital.value ? (
          <>
            <div className="vital-value">{vital.value}</div>
            <div className="vital-unit">{vital.unit}</div>
          </>
        ) : vital.textValue ? (
          <div className="vital-value vital-value--text">
            {getLocalizedResultText(vital.textValue)}
          </div>
        ) : null}
      </div>
      {hasDetail && (
        <span className="ecg-view-icon-btn" aria-hidden="true">
          <img src={expandIcon} alt="" />
        </span>
      )}
    </>
  );

  if (hasDetail) {
    return (
      <button type="button" className="vital-card vital-card--clickable" onClick={onClick}>
        {cardContent}
      </button>
    );
  }

  return <div className="vital-card">{cardContent}</div>;
};

export default VitalCard;
